import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IWithdrawDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const portfolioId = inject('portfolioId') as Ref<string>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetails>;

const description = computed(() => {
  return `Execução do resgate previsto para ${withdrawDetails.value.expectedRedemptionDate}`;
});

const conclusionDetails = computed(() => {
  return [
    {
      label: 'Liquidação prevista',
      value: withdrawDetails.value.expectedRedemptionDate
    },
    {
      label: 'Total a resgatar',
      value: `R$ ${amountFormatted.value}`
    },
    {
      label: 'Origem',
      value: withdrawDetails.value.portfolioName
    },
    {
      label: 'Destino',
      value: 'Conta'
    }
  ];
});

function goToPortfolio() {
  router.push({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value }
  });
}

return { __sfc: true,router, portfolioId, amountFormatted, withdrawDetails, description, conclusionDetails, goToPortfolio, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary }
}

})